module.exports = __webpack_public_path__ + "img/loginLogo.daafb6e0.png";